<template>
  <div>
    <vm-table
        ref="vmTable"
        height="50vh"
        :filter.sync="filter"
        module="basic"
        url="YiXinShipmentApplication"
        @select="selectHandle"
        @select-all="selectHandle">
      <div slot="toolbar">
        <el-button type="primary" @click="buyListDownLoadFile()">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="状态">
            <el-select v-model.trim="filter.statusName" clearable>
              <el-option label="草稿" :value="'草稿'"/>
              <el-option label="已完成" :value="'已完成'"/>
              <el-option label="谊新财务审核" :value="'谊新财务审核'"/>
              <el-option label="谊新采购审核" :value="'谊新采购审核'"/>
              <el-option label="谊新单证审核" :value="'谊新单证审核'"/>
              <el-option label="订单管理部审核" :value="'订单管理部审核'"/>
              <el-option label="谊新发运审核" :value="'谊新发运审核'"/>
              <el-option label="谊新单证审核2" :value="'谊新单证审核2'"/>
            </el-select>
          </vm-search>
          <vm-search label="流程编号">
            <el-input v-model.trim="filter.applicationNo" clearable/>
          </vm-search>
          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.factoryNo" clearable/>
          </vm-search>
          <vm-search label="申请人">
            <el-input v-model.trim="filter.creatorName" clearable/>
          </vm-search>
          <vm-search label="合同单位">
            <el-input v-model.trim="filter.unitCustomerName" clearable/>
          </vm-search>
        </div>
      </template>
<!--      <el-table-column type="selection" align="center" width="55" fixed="left"/>-->
      <el-table-column prop="statusName" align="center" width="150" label="状态"/>
      <el-table-column prop="title" align="center" width="200" label="标题" show-overflow-tooltip/>
      <el-table-column prop="applicationNo" align="center" width="150" label="流程编号">
        <template slot-scope="scope">
          <span style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.applicationNo}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="creatorName" align="center" width="100" label="申请人"/>
      <el-table-column prop="customerName" align="center" width="200" label="申请公司"/>
      <el-table-column prop="createTime" align="center" width="200" label="创建日期"/>
      <el-table-column
          prop="unitCustomerName"
          align="center"
          label="合同单位全称"
          width="200"
          show-overflow-tooltip/>
      <el-table-column prop="factoryNos" align="center" label="出厂编号" width="200" show-overflow-tooltip/>
      <el-table-column prop="deliveryDate" align="center" width="200" label="客户要求交货期"/>
      <el-table-column
          label="操作"
          width="200"
          align="center"
          fixed="right"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button
              type="primary"
              :disabled="scope.row.status!==0"
              @click="$refs.yiXinApplicationEdit.open(scope.row.pkid,1)">
            编辑
          </el-button>
          <el-button
              type="primary"
              :disabled="scope.row.status!==0"
              @click="submit(scope.row)">
            提交
          </el-button>
          <el-button
              type="danger"
              :disabled="scope.row.status!==0 "
              @click="deleteOne(scope.row.pkid)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </vm-table>
    <yi-xin-application-edit ref="yiXinApplicationEdit" @save-sucess="getList(1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import yiXinApplicationEdit from "@/views/salesManage/yiXinShipmentApplication/yiXinApplicationEdit";

  export default {
    name: "YiXinShipmentApplicationList",
    components: {VmTable, VmSearch, yiXinApplicationEdit},
    data() {
      return {
        selection: [],
        filter: {
          statusName: "",
          factoryNo:"",
          creatorName:"",
          unitCustomerName:"",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {

      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      deleteOne(pkid) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "YiXinShipmentApplication", pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      //下载清单
      buyListDownLoadFile() {
        this.downloadLoading = true;
        this.$http
          .exportFile("basic", "tianchangProductionOrder/export", this.filter)
          .then((resp) => {
            let blob = new Blob([resp.data]);
            let fileName = decodeURI(resp.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.downloadLoading = false;
          })
          .catch(() => {
            this.downloadLoading = false;
          });
      },

      submit(row) {
        this.$http.get("basic", `YiXinShipmentApplication/submit/${row.pkid}`)
          .then(() => {
            this.$message.success("提交成功");
            this.getList(1);
          }).catch(() => {
            this.$message.error("提交失败");
            this.getList(1);
          });
      },

      goto(row) {
        console.log(row);
        this.$router.push({
          path: "/yiXinApplicationPreview",
          query: {
            billId: row.pkid,
            $tabName: "谊新发货流程预览" + row.applicationNo,
          },
        });
      },


    },
  };
</script>
<style lang="scss" scoped>
</style>
